import * as React from 'react';

import { Search, X } from 'lucide-react';

import { cn } from '@/lib/utils';
import { getIconPixels } from '@/theme/size-tokens';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from './input-group';

type SearchInputProps = React.ComponentProps<'input'> & {
  wrapperClassName?: string;
  showClearButton?: boolean;
};

export function SearchInput({
  value,
  onChange,
  placeholder,
  disabled,
  showClearButton = true,
  type,
  className,
  wrapperClassName,
  ...props
}: SearchInputProps) {
  const hasValue = typeof value === 'string' && value.length > 0;

  const handleClear = () => {
    if (!onChange || !hasValue) return;

    const event = {
      target: { value: '' },
      currentTarget: { value: '' },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(event);
  };

  return (
    <div className={cn('w-full', wrapperClassName)}>
      <InputGroup className="w-full">
        <InputGroupAddon>
          <Search size={getIconPixels('sm', 'desktop')} aria-hidden="true" />
        </InputGroupAddon>
        <InputGroupInput
          {...props}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
          type={type ?? 'text'}
        />
        {showClearButton && hasValue && !disabled && (
          <InputGroupAddon align="inline-end">
            <InputGroupButton
              size="icon-xs"
              aria-label="Clear search"
              onClick={handleClear}
            >
              <X />
            </InputGroupButton>
          </InputGroupAddon>
        )}
      </InputGroup>
    </div>
  );
}
